<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Cihazlar">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek cihaz adı ,imei no benzersiz
                olmalıdır...</span
              >
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Cihaz Ekleme Formu">
            <b-row>
              <b-col md="12">
                <b-form-group label="Hava Limanları" label-for="airports">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Hava Limanları"
                  >
                    <v-select
                      id="airports"
                      v-model="selectedAirports"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="airports"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div>
                  <b-button
                    class="float-right"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    v-on:click="addAllAirports"
                  >
                    Tümünü Ekle
                  </b-button>
                  <b-button
                    class="float-right mr-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    v-on:click="removeAllAirports"
                  >
                    Tümünü Kaldır
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Cihaz IMEI" label-for="deviceImei">
                  <validation-provider
                    #default="{ errors }"
                    vid="deviceImei"
                    :rules="{ required: true, min: 15, max: 15 }"
                    name="Cihaz IMEI"
                  >
                    <b-form-input
                      id="deviceImei"
                      type="number"
                      v-model="deviceImei"
                      placeholder="Cihaz IMEI"
                      autocomplete="off"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Cihaz Adı" label-for="deviceName">
                  <validation-provider
                    #default="{ errors }"
                    vid="deviceName"
                    :rules="{ required: true }"
                    name="Cihaz Adı"
                  >
                    <b-form-input
                      id="deviceName"
                      type="text"
                      v-model="deviceName"
                      placeholder="Cihaz Adı"
                      autocomplete="off"
                      :state="errors.length > 0 ? false : null"
                      @keyup="deviceNameKeyup"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Tek Kullanımlık Giriş" label-for="oneTimeLogin">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Durum"
                  >
                    <b-form-checkbox id="oneTimeLogin" :checked="true" switch v-model="oneTimeLogin" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Aktif" label-for="active">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Durum"
                  >
                    <b-form-checkbox id="active" :checked="true" switch v-model="active" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <validation-provider
                  #default="{ errors }"
                  vid="password"
                  :rules="{ required: true, min: 8, max: 16 }"
                  name="Parola"
                >
                  <b-form-group label="Parola" label-for="password">
                    <b-form-input
                      id="password"
                      :type="passwordFieldType"
                      v-model="password"
                      placeholder="Parola"
                      autocomplete="off"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false : null"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Parola Tekrarı" label-for="passwordConfirmation">
                  <validation-provider
                    #default="{ errors }"
                    vid="password"
                    :rules="{ required: true, min: 8, max: 16 }"
                    name="Parola Tekrarı"
                  >
                    <b-form-input
                      id="passwordConfirmation"
                      :type="passwordFieldType"
                      v-model="passwordConfirmation"
                      placeholder="Parola Tekrarı"
                      autocomplete="off"
                      :state="errors.length > 0 ? false : null"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false, false)"
                  >
                    <b-spinner v-if="spinner === true" small />
                    {{ spinner === true ? "Kaydediliyor" : "Kaydet" }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Cihazlar">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>CİHAZ ID</th>
                    <th>CİHAZ IMEI</th>
                    <th>CİHAZ ADI</th>
                    <th>DURUM</th>
                    <th>TEK KULLANIMLIK GİRİŞ</th>
                    <th>GİRİŞ SAYISI</th>
                    <th>İŞLEMLER</th>
                    <th>OLUŞTURMA TARİHİ</th>
                  </thead>
                  <tbody>
                    <tr v-for="device in devices" :key="device.id">
                      <td>{{ device.id }}</td>
                      <td>{{ device.deviceId }}</td>
                      <td>{{ device.deviceImei }}</td>
                      <td>{{ device.deviceName }}</td>
                      <td>
                        <b-badge v-if="device.active == true" variant="light-success">
                          Aktif
                        </b-badge>
                        <b-badge v-if="device.active == false" variant="light-primary">
                          Pasif
                        </b-badge>
                      </td>
                      <td>
                        <b-badge
                          v-if="device.oneTimeLogin == true"
                          variant="light-success"
                        >
                          Aktif
                        </b-badge>
                        <b-badge
                          v-if="device.oneTimeLogin == false"
                          variant="light-primary"
                        >
                          Pasif
                        </b-badge>
                      </td>
                      <td>{{ device.loginCount }}</td>
                      <td>
                        <b-button-group class="float-right">
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-warning"
                            class="btn-icon rounded-circle mr-1"
                            :to="`/device/edit/${device.id}`"
                          >
                            <feather-icon icon="EditIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="deleteConfirmText(device.id)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </b-button-group>
                      </td>
                      <td>{{ device.createdAt }}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <th>#</th>
                    <th>CİHAZ ID</th>
                    <th>CİHAZ IMEI</th>
                    <th>CİHAZ ADI</th>
                    <th>DURUM</th>
                    <th>İŞLEMLER</th>
                    <th>OLUŞTURMA TARİHİ</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="1"
                    :total-rows="rows"
                    :per-page="12"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getDevices(value)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BPagination,
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BButtonGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
  BBadge,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
const endpoints = new Endpoints();

export default {
  components: {
    BPagination,
    BBadge,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BButtonGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      rows: 100,
      baseUrl: settings.apiBaseUrl,
      active: true,
      oneTimeLogin:false,
      devices: [],
      airports: [],
      password: "",
      deviceName: "",
      deviceImei: "",
      currentPage: 1,
      selectedAirports: [],
      passwordConfirmation: "",
      spinner: false,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal) {
        this.getDevices(newVal);
      },
      deep: true,
    },

    // deviceName(val) {
    //   this.deviceName = val.replace(/[^a-zA-Z0-9]/g, "")
    //     .split(" ")
    //     .join("")
    //     .trim()
    //     .toLowerCase();
    // },
  },
  methods: {
    deviceNameKeyup() {
      this.deviceName = this.deviceName
        .replace(/[^a-zA-Z0-9]/g, "")
        .split(" ")
        .join("")
        .trim()
        .toLowerCase();
    },
    addAllAirports() {
      this.selectedAirports = [...this.airports];
    },
    removeAllAirports() {
      this.selectedAirports = [];
    },
    getDevices(page) {
      endpoints
        .getDevices(page, this.$i18n.locale, () => {})
        .then((data) => {
          this.devices = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllAirports(page) {
      endpoints
        .getAllAirports(page, this.$i18n.locale, () => {})
        .then((data) => {
          this.airports = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText() {
      this.$swal({
        title: "Kayıt?",
        text: "Yeni cihazı kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let deviceAirports = [];

          for (let i = 0; i < this.selectedAirports.length; i++) {
            deviceAirports.push(this.selectedAirports[i].id);
          }
          endpoints
            .postDevices(
              {
                active: this.active,
                oneTimeLogin: this.oneTimeLogin,
                deviceImei: this.deviceImei,
                deviceName: this.deviceName,
                deviceAirports: deviceAirports,
                password: this.password,
                password_confirmation: this.passwordConfirmation,
              },
              this.$i18n.locale,
              () => {}
            )
            .then((data) => {
              this.spinner = false;

              if (!data.status) {
                this.$swal({
                  icon: "error",
                  title: "Hata!",
                  text: "Cihaz zaten kayıtlı.",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {});
              } else {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Yeni cihaz eklendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.deviceImei = "";
                    this.deviceName = "";
                    this.selectedDevices = [];
                    this.password = "";
                    this.passwordConfirmation = "";
                    this.getDevices(1);
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Cihazı silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteDevices(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getDevices(1);
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Cihazı silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getDevices(1);
    this.getAllAirports();
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
